import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@Component({
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss'],
  imports: [CommonModule, RouterModule, MatIconModule, MatListModule],
})
export class SidenavContentComponent {
  @Input()
  protected expanded?: string;

  @Output()
  public close: EventEmitter<void> = new EventEmitter<void>();

  protected onClick() {
    this.close.emit();
  }

  protected toggle(submenu: string) {
    this.expanded !== submenu ? (this.expanded = submenu) : (this.expanded = undefined);

    // Always return false in order to stop propagation of the click that would otherwise cause the sidenav to close.

    return false;
  }
}
